import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=0a81d0ed&scoped=true&"
import script from "./AdminList.vue?vue&type=script&lang=js&"
export * from "./AdminList.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/user-list.scss?vue&type=style&index=0&id=0a81d0ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a81d0ed",
  null
  
)

export default component.exports